import Link from "next/link";
import {NavigationItem} from "@/lib/interfaces/navigation";
import {usePathname} from "next/navigation";
import Image from "next/image";
import {Fragment, useState} from "react";
import { sanitiseSvg } from "@/lib/helpers/sanitise";

type NavMainProps = {
    items: NavigationItem[]
}

const SubNavItem = ({item}: {item: NavigationItem}) => {
    const href = item.page ? `/${item.page.slug}` : item.url ?? '#';
    return (
        <li key={item.id}>
            <Link href={href}>
                {item.anchor_text ?? item.title}
            </Link>
        </li>
    )
}

const SubNav = ({items, visible = false}: { items: NavigationItem[], visible: boolean }) => {
    return (
        <div className={`navMain-item__subNav ${visible ? 'm-visible' : ''}`}>
            <ul>
                {items.map(item => (
                    <SubNavItem key={item.id} item={item} />
                ))}
            </ul>
        </div>
    )
}

const NavItem = ({item}: {item: NavigationItem}) => {
    const [expand, setExpand] = useState(false);
    const pathname = usePathname();
    let icon = null;
    if (item.svg_icon) {
        icon = <span className="icon" dangerouslySetInnerHTML={{__html: sanitiseSvg(item.svg_icon)}}></span>
    } else if(item.media.length) {
        const image = item.media.find(media => {
            return media.role == 'icon';
        });
        if (image) {
            icon = <Image src={image.cropped_png} alt={`Icon for ${item.title}`} width={24} height={24} />
        }
    }
    const href = item.page ? `/${item.page.slug}` : item.url ?? '#';
    return (
        <div className={"navMain-item-container"} onMouseOver={() => setExpand(true)} onMouseOut={() => setExpand(false)}>
            <Link key={item.id} href={href} className={`navMain-item ${pathname == href ? 'm-selected' : ''}`}>
                {icon}
                <span className={`label`}>{item.anchor_text ?? item.title}</span>
            </Link>
            {item.children.length > 0 &&
                <SubNav items={item.children} visible={expand} />
            }
        </div>
    )
}

export default function NavMain(props: NavMainProps) {
    const items = props.items.map(item => {
        return <NavItem key={item.id} item={item}/>
    });
    return (
        <nav className="eo-navMain">
            {items}
        </nav>
    )
}